export { default } from './jssPreset';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/styles/esm/jssPreset/index.js
// module id = 614
// module chunks = 121